import { RootState } from '@Core/Communication'
import { CookiesStorage } from '@Core/Communication/GlobalStore/CookiesStorage/CookiesStorage'
import { LAST_PROVIDER_KEY, useAuth } from '@Core/Hooks/useAuth'
import { Actions } from '@Entry/Login/Login.styles'
import { BadgeFace, LoginBadge } from '@Entry/Login/LoginBadge'
import { LoginForm } from '@Entry/Login/LoginForm'
import { MicrosoftLoginButton } from '@Entry/Login/MicrosoftLoginButton'
import { OAuthProvider } from 'firebase/auth'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
const storage = new CookiesStorage()

export const SessionExpired = () => {
    const { isSessionExpired } = useSelector(
        (state: RootState) => state.authentication
    )
    const { authenticate, uiAuthenticate, loading } = useAuth(
        storage,
        new OAuthProvider('microsoft.com'),
        true
    )
    // Same method as the last sign-in, so the user is not sent to a form
    // that their account cannot use.
    const usedMicrosoft = storage.getItem(LAST_PROVIDER_KEY) === 'microsoft.com'

    useEffect(() => {
        if (!isSessionExpired && !storage.getItem('@ofc:accessToken')) {
            toast.error(
                'Ops, sua sessão expirou. Por favor, faça login novamente.'
            )
        }
    }, [isSessionExpired])

    if (!isSessionExpired) return null

    // Same badge as the login screen, laid over the page: the app underneath
    // stays mounted, so whatever the user was doing is still there after signing in.
    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 1300,
                overflowY: 'auto',
            }}
        >
            <LoginBadge>
                <BadgeFace
                    title="Sua sessão expirou"
                    subtitle={
                        usedMicrosoft
                            ? 'Entre novamente para continuar de onde parou'
                            : 'Entre com e-mail e senha para continuar de onde parou'
                    }
                >
                    <Actions>
                        {usedMicrosoft ? (
                            <MicrosoftLoginButton onClick={authenticate} loading={loading} />
                        ) : (
                            <LoginForm uiAuthenticate={uiAuthenticate} loading={loading} />
                        )}
                    </Actions>
                </BadgeFace>
            </LoginBadge>
        </div>
    )
}
